import React from 'react'
import Cookies from 'universal-cookie'
import api from '../../api/api'
import { withTranslation } from 'react-i18next'
import { Card, CardHeader, CardBody, Spinner } from 'reactstrap'
import PropTypes from 'prop-types'
import { processError } from '../../lib/lib'
const cookies = new Cookies()

class Bill extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            errorMessage: '',
        }
    }

    checkBillStatus(data) {
        return new Promise((resolve, reject) => {
            api.checkBillStatus(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    async componentWillMount() {
        const { t } = this.props
        const token = cookies.get('accessToken')
        const billId = this.props.match.params.billId
        const checkBill = setInterval(async () => {
            const { success, statusCode } = await this.checkBillStatus({ token, billId })
            if (success) {
                clearInterval(checkBill)
                cookies.set('order', [], { path: '/' })
                this.props.history.push('/study')
            } else {
                if (statusCode !== 0) {
                    clearInterval(checkBill)
                    if (statusCode === 404) this.setState({ errorMessage: t('bill-not-found') })
                    if (statusCode === 2) this.setState({ errorMessage: t('bill-already-payed') })
                }
            }
        }, 5000)
    }

    render() {
        const { t } = this.props
        return (
            <div className="certificate-wrapper">
                <Card className="nostudy-card m-0">
                    <CardHeader className="d-flex align-items-center flex-column">
                        <span className="title lg-font-size">{t('bill-await')}</span>
                    </CardHeader>
                    <CardBody className="d-flex justify-content-center">
                        {
                            this.state.errorMessage ?
                                <span className="subtitle md-font-size">{this.state.errorMessage}</span> :
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    style={{ width: '3rem', height: '3rem' }}
                                    role="status"
                                    aria-hidden="true"
                                />
                        }
                    </CardBody>
                </Card>
            </div>
        )
    }
}

Bill.propTypes = {
    history: PropTypes.object,
    t: PropTypes.func,
    match: PropTypes.object,
}

export default withTranslation()(Bill)



// WEBPACK FOOTER //
// ./src/views/Cart/Bill.jsx